export const environment = {
  production: false,

  adminUserId: "",

  name: "Bebop development",
  envName: "Development",
  version: "0.0.1-dev",

  // PWA basic auth is now configured at runtime via window.__BEBOP_RUNTIME_CONFIG__.
  // Keep these empty to avoid shipping demo credentials in the client bundle.
  pwaAuth: {
    enabled: false,
    username: "",
    password: ""
  },

  apiBaseUrl: "",

  firebaseConfig: {
    apiKey: "AIzaSyDXsHl-IBNXz8gYGv36R_ok5-89u-ylhqU",
    authDomain: "bebop-dev-a91c3.firebaseapp.com",
    projectId: "bebop-dev-a91c3",
    storageBucket: "bebop-dev-a91c3.appspot.com",
    messagingSenderId: "1091824022035",
    appId: "1:1091824022035:web:2b60c62dae37cda585c5e6",
    measurementId: "G-P8DBXB79J5",
    vapid: "BAR6r8UgSlBbtCy6kxc-pYQJAZWSPhJqzdHxU_2AJDz5XmxChhxRd5eWwrcDbvVdqJ_7IuU0NeS5hOEtrO_Y_zw"
  }
};